"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.lead ? _c("div", {
    staticClass: "qm-wrap"
  }, [["New", "Contacted"].includes(_vm.lead.status) ? _c("div", [_vm.lead.productAction === "Send Options" || _vm.lead.productAction === "Send Quote" || _vm.lead.productAction === "Sourcing" ? _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [!["Request Approval", "Request Options Approval"].includes(_vm.lead.quotationStatus) ? _c("leads-product-grid", {
    attrs: {
      id: _vm.leadId,
      lead: _vm.lead,
      "added-variation-ids": _vm.addedVariationIds
    },
    on: {
      sendProductOptions: _vm.handlProductOptions
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e(), _c("div", {
    staticClass: "qm-summary-bar"
  }, [_vm.lead.quotationStatus === "Request Approval" && _vm.loggedInUser.roles.indexOf("Super Admin") > -1 ? _c("div", {
    staticClass: "qm-summary-actions"
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.previewLoading,
      expression: "previewLoading"
    }],
    staticClass: "qm-btn qm-btn--preview",
    attrs: {
      disabled: _vm.leadsProductList.length === 0,
      size: "small",
      icon: "el-icon-full-screen"
    },
    on: {
      click: _vm.previewQuote
    }
  }, [_vm._v(" Preview ")]), _c("el-popconfirm", {
    attrs: {
      title: "Are you sure to Approve?"
    },
    on: {
      confirm: _vm.approveQuote
    }
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.approveLoading,
      expression: "approveLoading"
    }],
    staticClass: "qm-btn qm-btn--approve",
    attrs: {
      slot: "reference",
      disabled: _vm.leadsProductList.length === 0,
      size: "small"
    },
    slot: "reference"
  }, [_vm._v(" Approve ")])], 1), _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.rejectLoading,
      expression: "rejectLoading"
    }],
    staticClass: "qm-btn qm-btn--reject",
    attrs: {
      disabled: _vm.leadsProductList.length === 0,
      size: "small"
    },
    on: {
      click: function ($event) {
        _vm.rejectDialogVisible = true;
      }
    }
  }, [_vm._v(" Reject ")])], 1) : _vm._e(), _vm.presentationEnabled && _vm.lead.quotationStatus === "Request Options Approval" && _vm.loggedInUser.roles.indexOf("Super Admin") > -1 ? _c("div", {
    staticClass: "qm-summary-actions"
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.previewLoading,
      expression: "previewLoading"
    }],
    staticClass: "qm-btn qm-btn--preview",
    attrs: {
      disabled: _vm.leadsProductList.length === 0,
      size: "small",
      icon: "el-icon-full-screen"
    },
    on: {
      click: _vm.previewPresentation
    }
  }, [_vm._v(" Preview Presentation ")]), _c("el-popconfirm", {
    attrs: {
      title: "Are you sure to Approve Options?"
    },
    on: {
      confirm: _vm.approveOptionsHandler
    }
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.approveLoading,
      expression: "approveLoading"
    }],
    staticClass: "qm-btn qm-btn--approve",
    attrs: {
      slot: "reference",
      disabled: _vm.leadsProductList.length === 0,
      size: "small"
    },
    slot: "reference"
  }, [_vm._v(" Approve Options ")])], 1), _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.rejectLoading,
      expression: "rejectLoading"
    }],
    staticClass: "qm-btn qm-btn--reject",
    attrs: {
      disabled: _vm.leadsProductList.length === 0,
      size: "small"
    },
    on: {
      click: function ($event) {
        _vm.rejectDialogVisible = true;
      }
    }
  }, [_vm._v(" Reject Options ")])], 1) : _vm._e()]), _c("div", {
    staticClass: "qm-body"
  }, [_c("div", {
    staticClass: "qm-right"
  }, [_c("div", {
    staticClass: "qm-gst-card"
  }, [_c("div", {
    staticClass: "qm-gst-row"
  }, [_c("span", {
    staticClass: "qm-gst-label"
  }, [_vm._v("Total:")]), _c("span", {
    staticClass: "qm-gst-value"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.lead.total)))])]), _c("div", {
    staticClass: "qm-gst-row"
  }, [_c("span", {
    staticClass: "qm-gst-label"
  }, [_vm._v("GST (" + _vm._s(_vm.lead.taxRate) + "%):")]), _c("span", {
    staticClass: "qm-gst-value qm-gst-value--tax"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.lead.taxAmount)))])]), _vm.lead.transportTax || _vm.lead.packingTax ? _c("div", {
    staticClass: "qm-gst-row"
  }, [_c("span", {
    staticClass: "qm-gst-label"
  }, [_vm._v("Packing & Transport Tax (18%):")]), _c("span", {
    staticClass: "qm-gst-value qm-gst-value--tax"
  }, [_vm._v(_vm._s(_vm.formatCurrency((_vm.lead.transportTax || 0) + (_vm.lead.packingTax || 0))))])]) : _vm._e(), _c("div", {
    staticClass: "qm-gst-divider"
  }), _c("div", {
    staticClass: "qm-gst-row"
  }, [_c("span", {
    staticClass: "qm-gst-label"
  }, [_vm._v("Total Qty:")]), _c("span", {
    staticClass: "qm-gst-value"
  }, [_vm._v(_vm._s(_vm.formatInteger(_vm.lead.totalQuality)))])]), !_vm.isInstec && _vm.lead.discount ? _c("div", {
    staticClass: "qm-gst-row"
  }, [_c("span", {
    staticClass: "qm-gst-label"
  }, [_vm._v("Discount:")]), _c("span", {
    staticClass: "qm-gst-value",
    staticStyle: {
      color: "#f56c6c"
    }
  }, [_vm._v("-" + _vm._s(_vm.formatCurrency(_vm.lead.discount)))])]) : _vm._e(), _c("div", {
    staticClass: "qm-gst-row qm-gst-row--grand"
  }, [_c("span", {
    staticClass: "qm-gst-label",
    staticStyle: {
      "font-weight": "700",
      color: "#1a1d2e"
    }
  }, [_vm._v("Grand Total:")]), _c("span", {
    staticClass: "qm-gst-value qm-gst-value--grand"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.lead.grandTotal)))])])])]), _c("div", {
    staticClass: "qm-left"
  }, [_vm._l(_vm.leadsProductList, function (item, index) {
    return _c("div", {
      key: item.id || index,
      staticClass: "qm-product-card"
    }, [_c("div", {
      staticClass: "qm-product-thumb"
    }, [item.image1 ? _c("el-image", {
      staticStyle: {
        width: "100%",
        height: "100%"
      },
      attrs: {
        src: `${item.image1}-md`,
        "preview-src-list": [item.image1 + "-og"],
        fit: "contain"
      }
    }) : _c("div", {
      staticClass: "qm-thumb-placeholder"
    }, [_c("i", {
      staticClass: "el-icon-picture-outline"
    })])], 1), _c("div", {
      staticClass: "qm-product-info"
    }, [_c("div", {
      staticClass: "qm-product-name"
    }, [_vm._v(" " + _vm._s(item.productName || item.productsVariation && item.productsVariation.product && item.productsVariation.product.name || item.productsVariation && item.productsVariation.productName || item.productsVariation && item.productsVariation.name || "—") + " ")]), _c("div", {
      staticClass: "qm-product-fields"
    }, [_c("div", {
      staticClass: "qm-field"
    }, [_c("span", {
      staticClass: "qm-field-label"
    }, [_vm._v("Quote Price")]), _c("span", {
      staticClass: "qm-field-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(item.unitPrice)))])]), _c("div", {
      staticClass: "qm-field"
    }, [_c("span", {
      staticClass: "qm-field-label"
    }, [_vm._v("Negotiated Price")]), _c("el-input-number", {
      staticClass: "qm-input-number",
      attrs: {
        disabled: _vm.disableInputs(),
        size: "small",
        min: _vm.loggedInUser.adminsRoleId === 4 ? (item.unitPrice || 0) * _vm.negotiatedPriceLimitMultiplier : 0,
        precision: 2
      },
      on: {
        input: function ($event) {
          return _vm.calculate(index);
        }
      },
      model: {
        value: item.salePrice,
        callback: function ($$v) {
          _vm.$set(item, "salePrice", $$v);
        },
        expression: "item.salePrice"
      }
    })], 1), _c("div", {
      staticClass: "qm-field"
    }, [_c("span", {
      staticClass: "qm-field-label"
    }, [_vm._v("Quantity")]), _c("el-input-number", {
      staticClass: "qm-input-number",
      attrs: {
        disabled: _vm.disableInputs(),
        size: "mini",
        min: 1
      },
      on: {
        change: function ($event) {
          return _vm.calculate(index);
        }
      },
      model: {
        value: item.quantity,
        callback: function ($$v) {
          _vm.$set(item, "quantity", $$v);
        },
        expression: "item.quantity"
      }
    })], 1), _vm.isInstec ? _c("div", {
      staticClass: "qm-field"
    }, [_c("span", {
      staticClass: "qm-field-label"
    }, [_vm._v("Discount")]), _c("el-input-number", {
      staticClass: "qm-input-number qm-input-number--percent",
      attrs: {
        disabled: _vm.disableInputs(),
        controls: false,
        size: "small",
        min: 0,
        max: 100,
        precision: 0
      },
      on: {
        input: function ($event) {
          return _vm.calculate(index);
        }
      },
      model: {
        value: item.discount,
        callback: function ($$v) {
          _vm.$set(item, "discount", $$v);
        },
        expression: "item.discount"
      }
    })], 1) : _vm._e(), _c("div", {
      staticClass: "qm-field"
    }, [_c("span", {
      staticClass: "qm-field-label"
    }, [_vm._v("Sub Total")]), _c("span", {
      staticClass: "qm-field-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(item.subTotal)))])]), _c("div", {
      staticClass: "qm-field"
    }, [_c("span", {
      staticClass: "qm-field-label"
    }, [_vm._v("Tax(" + _vm._s(item.taxRate) + "%)")]), _c("span", {
      staticClass: "qm-field-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(item.taxAmount)))])]), _c("div", {
      staticClass: "qm-field qm-field--comments"
    }, [_c("span", {
      staticClass: "qm-field-label"
    }, [_vm._v("Comments")]), ["Yet To Quote", "Revise Options", "Options Rejected", "Request Options Approval"].includes(_vm.lead.quotationStatus) && _vm.lead.productAction === "Send Options" ? _c("el-input", {
      attrs: {
        placeholder: "Comments",
        disabled: _vm.disableInputs(),
        type: "textarea",
        autosize: {
          minRows: 1,
          maxRows: 6
        },
        maxlength: "300",
        "show-word-limit": ""
      },
      model: {
        value: item.comments,
        callback: function ($$v) {
          _vm.$set(item, "comments", $$v);
        },
        expression: "item.comments"
      }
    }) : _c("el-input", {
      attrs: {
        placeholder: "Comments",
        disabled: _vm.disableInputs(),
        type: "textarea",
        autosize: {
          minRows: 1,
          maxRows: 6
        },
        maxlength: "300",
        "show-word-limit": ""
      },
      model: {
        value: item.quoteComments,
        callback: function ($$v) {
          _vm.$set(item, "quoteComments", $$v);
        },
        expression: "item.quoteComments"
      }
    })], 1)])]), _c("div", {
      staticClass: "qm-product-actions"
    }, [_c("el-popconfirm", {
      attrs: {
        title: "Are you sure to delete this?"
      },
      on: {
        confirm: function ($event) {
          return _vm.removeRow(index, item);
        }
      }
    }, [_c("el-button", {
      staticClass: "qm-delete-btn",
      attrs: {
        slot: "reference",
        type: "danger",
        circle: "",
        size: "mini",
        icon: "el-icon-delete"
      },
      slot: "reference"
    })], 1)], 1)]);
  }), ["Request Approval", "Quote Rejected", "Client d Options", "Yet To Quote"].includes(_vm.lead.quotationStatus) || _vm.lead.quotationStatus === "Yet To Quote" && _vm.lead.productAction === "Sourcing" ? _c("div", [_c("div", {
    staticClass: "qm-charge-row"
  }, [_vm._m(0), _c("span", {
    staticClass: "qm-charge-label"
  }, [_vm._v("Transport Charges")]), _c("div", {
    staticClass: "qm-charge-inputs"
  }, [_c("el-input", {
    staticClass: "qm-charge-pct-input",
    attrs: {
      type: "number",
      size: "small"
    },
    on: {
      input: _vm.handleTransportPercentageChange
    },
    model: {
      value: _vm.lead.transportChargesPercentage,
      callback: function ($$v) {
        _vm.$set(_vm.lead, "transportChargesPercentage", $$v);
      },
      expression: "lead.transportChargesPercentage"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v(" % ")])], 2), _c("el-input", {
    staticClass: "qm-charge-value-input",
    attrs: {
      type: "number",
      size: "small"
    },
    on: {
      input: _vm.handleTransportValueChange
    },
    model: {
      value: _vm.lead.transportChargesValue,
      callback: function ($$v) {
        _vm.$set(_vm.lead, "transportChargesValue", $$v);
      },
      expression: "lead.transportChargesValue"
    }
  }, [_c("template", {
    slot: "prepend"
  }, [_vm._v(" ₹ ")])], 2)], 1)]), _c("div", {
    staticClass: "qm-charge-row",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._m(1), _c("span", {
    staticClass: "qm-charge-label"
  }, [_vm._v("Packing Charges")]), _c("div", {
    staticClass: "qm-charge-inputs"
  }, [_c("el-input", {
    staticClass: "qm-charge-pct-input",
    attrs: {
      type: "number",
      size: "small"
    },
    on: {
      input: _vm.handlePackingPercentageChange
    },
    model: {
      value: _vm.lead.packingChargesPercentage,
      callback: function ($$v) {
        _vm.$set(_vm.lead, "packingChargesPercentage", $$v);
      },
      expression: "lead.packingChargesPercentage"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v(" % ")])], 2), _c("el-input", {
    staticClass: "qm-charge-value-input",
    attrs: {
      type: "number",
      size: "small"
    },
    on: {
      input: _vm.handlePackingValueChange
    },
    model: {
      value: _vm.lead.packingChargesValue,
      callback: function ($$v) {
        _vm.$set(_vm.lead, "packingChargesValue", $$v);
      },
      expression: "lead.packingChargesValue"
    }
  }, [_c("template", {
    slot: "prepend"
  }, [_vm._v(" ₹ ")])], 2)], 1)]), !_vm.isInstec ? _c("div", {
    staticClass: "qm-charge-row",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._m(2), _c("span", {
    staticClass: "qm-charge-label"
  }, [_vm._v("Discount")]), _c("div", {
    staticClass: "qm-charge-inputs"
  }, [_c("el-input", {
    staticClass: "qm-charge-pct-input",
    attrs: {
      type: "number",
      size: "small"
    },
    on: {
      input: _vm.handleDiscountPercentageChange
    },
    model: {
      value: _vm.lead.discountPercentage,
      callback: function ($$v) {
        _vm.$set(_vm.lead, "discountPercentage", $$v);
      },
      expression: "lead.discountPercentage"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v(" % ")])], 2), _c("el-input", {
    staticClass: "qm-charge-value-input",
    attrs: {
      type: "number",
      size: "small"
    },
    on: {
      input: _vm.handleDiscountValueChange
    },
    model: {
      value: _vm.lead.discount,
      callback: function ($$v) {
        _vm.$set(_vm.lead, "discount", $$v);
      },
      expression: "lead.discount"
    }
  }, [_c("template", {
    slot: "prepend"
  }, [_vm._v(" ₹ ")])], 2)], 1)]) : _vm._e()]) : _vm._e(), ["Request Approval", "Quote Rejected", "Client Approved Options", "Yet To Quote"].includes(_vm.lead.quotationStatus) || _vm.lead.quotationStatus === "Yet To Quote" && _vm.lead.productAction === "Sourcing" ? _c("div", {
    staticClass: "qm-collapsibles"
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      xs: 24,
      sm: 24,
      md: 12
    }
  }, [_c("el-collapse", [_c("el-collapse-item", {
    attrs: {
      name: "tnc"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("span", {
    staticClass: "qm-collapse-title"
  }, [_c("i", {
    staticClass: "el-icon-document"
  }), _vm._v(" Terms & Conditions")])]), _c("editor", {
    attrs: {
      "api-key": "06degwxbku50vc1z9mfncwggxbc7qkzuf0zxjh24adh16y7s",
      init: {
        height: 300,
        plugins: ["lists link image paste help wordcount"],
        toolbar: "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",
        content_style: "body { font-size: 10pt; } p { margin: 0; }",
        forced_root_block: ""
      }
    },
    model: {
      value: _vm.lead.tnc,
      callback: function ($$v) {
        _vm.$set(_vm.lead, "tnc", $$v);
      },
      expression: "lead.tnc"
    }
  })], 2)], 1)], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 24,
      md: 12
    }
  }, [_c("el-collapse", [_c("el-collapse-item", {
    attrs: {
      name: "notes"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("span", {
    staticClass: "qm-collapse-title"
  }, [_c("i", {
    staticClass: "el-icon-chat-line-square"
  }), _vm._v(" Notes")])]), _c("editor", {
    attrs: {
      "api-key": "06degwxbku50vc1z9mfncwggxbc7qkzuf0zxjh24adh16y7s",
      init: {
        height: 180,
        plugins: ["lists link image paste help wordcount"],
        toolbar: "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",
        content_style: "body { font-size: 10pt; } p { margin: 0; }",
        forced_root_block: ""
      }
    },
    model: {
      value: _vm.lead.quoteExtraNote,
      callback: function ($$v) {
        _vm.$set(_vm.lead, "quoteExtraNote", $$v);
      },
      expression: "lead.quoteExtraNote"
    }
  })], 2)], 1)], 1)], 1)], 1) : _vm._e()], 2)]), _c("div", {
    staticClass: "qm-footer-actions"
  }, [["Yet To Quote", "Revise Options", "Options Rejected"].includes(_vm.lead.quotationStatus) && (_vm.presentationEnabled || _vm.lead.productAction !== "Send Options") && !(_vm.loggedInUser.roles.indexOf("Admin") > -1) && !(_vm.loggedInUser.roles.indexOf("Super Admin") > -1) ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    staticClass: "qm-btn qm-btn--preview",
    attrs: {
      disabled: _vm.leadsProductList.length === 0,
      round: ""
    },
    on: {
      click: function ($event) {
        return _vm.saveProducts(true);
      }
    }
  }, [_vm._v(" Preview ")]) : _vm._e(), _vm.lead.productAction !== "Sourcing" && ["Yet To Quote", "Revise Options", "Options Rejected"].includes(_vm.lead.quotationStatus) && !(_vm.loggedInUser.roles.indexOf("Admin") > -1) && !(_vm.loggedInUser.roles.indexOf("Super Admin") > -1) ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    staticClass: "qm-btn qm-btn--send",
    attrs: {
      disabled: _vm.leadsProductList.length === 0,
      round: ""
    },
    on: {
      click: function ($event) {
        _vm.lead.productAction === "Send Quote" ? _vm.requestApproval() : _vm.saveProducts();
      }
    }
  }, [_vm._v(" Send for Approval ")]) : _vm._e(), _vm.presentationEnabled && _vm.lead.productAction === "Send Options" && ["Yet To Quote", "Revise Options", "Options Rejected"].includes(_vm.lead.quotationStatus) && !(_vm.loggedInUser.roles.indexOf("Admin") > -1) && !(_vm.loggedInUser.roles.indexOf("Super Admin") > -1) ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.sendDirectLoading,
      expression: "sendDirectLoading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "qm-btn qm-btn--direct",
    attrs: {
      disabled: _vm.leadsProductList.length === 0,
      round: ""
    },
    on: {
      click: _vm.sendDirectOptionsToClientHandler
    }
  }, [_vm._v(" Send Directly to Client ")]) : _vm._e(), ["Request Approval", "Quote Approved", "Quote Rejected", "Client Approved Options"].includes(_vm.lead.quotationStatus) && !(_vm.loggedInUser.roles.indexOf("Admin") > -1) && !(_vm.loggedInUser.roles.indexOf("Super Admin") > -1) ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.previewLoading,
      expression: "previewLoading"
    }],
    staticClass: "qm-btn qm-btn--preview",
    attrs: {
      disabled: _vm.leadsProductList.length === 0,
      icon: "el-icon-full-screen",
      round: ""
    },
    on: {
      click: _vm.previewQuote
    }
  }, [_vm._v(" Preview ")]) : _vm._e(), (["Request Approval", "Quote Approved", "Quote Rejected", "Client Approved Options"].includes(_vm.lead.quotationStatus) || _vm.lead.quotationStatus === "Yet To Quote" && _vm.lead.productAction === "Sourcing") && !(_vm.loggedInUser.roles.indexOf("Admin") > -1) && !(_vm.loggedInUser.roles.indexOf("Super Admin") > -1) ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "qm-btn qm-btn--approve",
    attrs: {
      disabled: _vm.leadsProductList.length === 0,
      round: ""
    },
    on: {
      click: _vm.requestApproval
    }
  }, [_vm._v(" Send for Approval ")]) : _vm._e(), (["Request Approval", "Quote Approved", "Quote Rejected", "Client Approved Options"].includes(_vm.lead.quotationStatus) || _vm.lead.quotationStatus === "Yet To Quote" && (_vm.lead.productAction === "Sourcing" || _vm.lead.productAction === "Send Quote")) && !(_vm.loggedInUser.roles.indexOf("Admin") > -1) && !(_vm.loggedInUser.roles.indexOf("Super Admin") > -1) ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.sendDirectLoading,
      expression: "sendDirectLoading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "qm-btn qm-btn--direct",
    attrs: {
      disabled: _vm.leadsProductList.length === 0,
      round: ""
    },
    on: {
      click: _vm.sendDirectToClientHandler
    }
  }, [_vm._v(" Send Directly to Client ")]) : _vm._e()], 1), _vm.presentationEnabled ? _c("el-dialog", {
    style: {
      maxWidth: "800px",
      margin: "0 auto"
    },
    attrs: {
      title: "Presentation",
      visible: _vm.previewDialogVisible,
      width: "95%",
      center: ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.previewDialogVisible = $event;
      }
    }
  }, [_vm.optionPreviewUrl ? _c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      src: _vm.optionPreviewUrl
    }
  }) : _vm._e()]) : _vm._e(), _c("el-dialog", {
    style: {
      maxWidth: "500px",
      margin: "0 auto"
    },
    attrs: {
      title: "Reason for rejection",
      visible: _vm.rejectDialogVisible,
      width: "95%",
      center: ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.rejectDialogVisible = $event;
      }
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%",
      "margin-bottom": "12px"
    },
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Reason"
    },
    model: {
      value: _vm.rejectReason,
      callback: function ($$v) {
        _vm.rejectReason = $$v;
      },
      expression: "rejectReason"
    }
  }, _vm._l(_vm.reasonList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1), _c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3,
      autosize: {
        minRows: 3,
        maxRows: 4
      },
      maxlength: "250",
      "show-word-limit": "",
      placeholder: "Additional comments (optional)"
    },
    model: {
      value: _vm.rejectReasonComment,
      callback: function ($$v) {
        _vm.rejectReasonComment = $$v;
      },
      expression: "rejectReasonComment"
    }
  }), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.rejectDialogVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.rejectLoading
    },
    on: {
      click: function ($event) {
        _vm.lead.quotationStatus === "Request Options Approval" ? _vm.rejectOptionsHandler() : _vm.rejectQuote();
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "qm-charge-icon qm-charge-icon--transport"
  }, [_c("i", {
    staticClass: "el-icon-truck"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "qm-charge-icon qm-charge-icon--packing"
  }, [_c("i", {
    staticClass: "el-icon-box"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "qm-charge-icon qm-charge-icon--discount",
    staticStyle: {
      "background-color": "#f5f7fa",
      color: "#909399"
    }
  }, [_c("i", {
    staticClass: "el-icon-discount"
  })]);
}];
render._withStripped = true;